export default "__VITE_ASSET__a088cc42__"